//Components
import { NavLink, Link } from 'react-router-dom';
import { Fragment, useState } from 'react';
//Styles
import '../../styles/navigation.css';
//Icons
import { FaFacebook, FaInstagram } from "react-icons/fa";


function Navbar() {

	const [menuOpen, setMenuOpen] = useState(false);

	const toggleMenu = () => {
    	setMenuOpen(!menuOpen);
  	};

	return (
		<div className='container-all-navbar'>	
				<div className='container-navbar-upper'>
					<div className='contain-navbar-upper'>
						<Link to='https://wa.me/+5491162180101?text=Hola,%20me%20interesan%20sus%20servicios%20legales.' className='navbar-upper-link' style={{textDecoration: 'none'}}>+54 9 11 6218-0101</Link>
						<p>|</p>
						<Link to='https://calendly.com/veronicavegaabogada/30min' className='navbar-upper-link' style={{textDecoration: 'none'}}>Agenda una cita</Link>
					</div>
					<div className='navbar-upper-social'>
						<Link to='https://www.facebook.com/veronicavegaabogada' style={{textDecoration: 'none'}} target='_blank' className='upper-social-media facebook'><FaFacebook /></Link>
						<Link to='https://www.instagram.com/veronica_vega_abogada/' style={{textDecoration: 'none'}} target='_blank' className='upper-social-media instagram'><FaInstagram /></Link>
					</div>
				</div>
			<div className='container-navbar'>
				<div className='container-logo'>
					<Link to='/' style={{textDecoration: 'none'}}><img src={require(`../../images/logo.webp`)} alt='logo' /></Link>
					<p className=''>Verónica<br/>Vega & Asoc.</p>
				</div>
				<div className={`container-navlinks navbar ${menuOpen ? 'menu-active' : ''}`}>
					<NavLink to='/' className={`btn-navbar ${isActive => isActive ? 'active' : ''}`} style={{textDecoration: 'none'}}><span>Inicio</span></NavLink>
					<NavLink to='/#about' className='btn-navbar' style={{textDecoration: 'none'}}><span>Sobre Mí</span></NavLink>
					<NavLink to='/#practice' className='btn-navbar' style={{textDecoration: 'none'}}>Áreas de Práctica</NavLink>
					<NavLink to='/#contact' className='btn-navbar' style={{textDecoration: 'none'}}>Contacto</NavLink>
				</div>
				<button className='nav-open-btn' id='menu-toggle' aria-label='Toggle Menu' onClick={toggleMenu}>
					<span className={`line ${menuOpen ? 'line-1' : ''}`}></span>
					<span className={`line ${menuOpen ? 'line-2' : ''}`}></span>
					<span className={`line ${menuOpen ? 'line-3' : ''}`}></span>
				</button>
			</div>
		</div>
	);
};

export default Navbar;